import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import QueryParamsProxy from '../../utils/queryParamProxy';
import Utils from '../../utils';
import RouteParamConstants, { PurchaseFinishedResults, PurchaseTypes } from '../../utils/routeParamConstants';
import SettingsScreensEnum from '../Settings/utils/SettingsScreensEnum';
import InboxMessagesProvider from '../../components/InboxMessagesProvider';
import Screens from '../index';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { PaymentProviders } from '../../utils/paymentProviders';
import { KYC_STATUS } from '../../utils/kyc/Constants';
import store from '../../state/store';
import { PLATFORM } from '../../constants';
import { sendDataToCAMS } from './utils';
var PurchaseFlow = /*#__PURE__*/function (_Component) {
  function PurchaseFlow(props) {
    var _this;
    _classCallCheck(this, PurchaseFlow);
    _this = _callSuper(this, PurchaseFlow, [props]);
    _this.checkLTOOnExit = function () {
      var _this$props = _this.props,
        ltoOffer = _this$props.ltoOffer,
        clearLTOOffer = _this$props.clearLTOOffer;
      if (ltoOffer) {
        var currentTimestamp = Date.now();
        var ltoTimestamp = ltoOffer === null || ltoOffer === void 0 ? void 0 : ltoOffer.OFFER_END_TIME;
        if (currentTimestamp >= ltoTimestamp) {
          clearLTOOffer();
        }
      }
    };
    _this._nextHandle = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(success, validatedData) {
        var addressAvailable,
          _this$state,
          stage,
          form,
          promoReward,
          promoCode,
          purchaseType,
          packageId,
          dynamicTriggeredSaleId,
          statePackage,
          _this$props2,
          setPrePurchaseRoute,
          navigation,
          setPrePurchaseRouteParams,
          setPromoCode,
          formUrl,
          KYCResult,
          setPrePurchaseData,
          postStartWebPurchase,
          redirecturl,
          ptype,
          buyItemParams,
          response,
          newStage,
          cardNickname,
          creditCardType,
          lastDigits,
          routeParams,
          activeRouteState,
          activeRouteStateParams,
          gid,
          _ptype,
          billingInfo,
          _buyItemParams,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              addressAvailable = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              _this$state = _this.state, stage = _this$state.stage, form = _this$state.form, promoReward = _this$state.promoReward, promoCode = _this$state.promoCode, purchaseType = _this$state.purchaseType, packageId = _this$state.packageId, dynamicTriggeredSaleId = _this$state.dynamicTriggeredSaleId, statePackage = _this$state.package;
              _this$props2 = _this.props, setPrePurchaseRoute = _this$props2.setPrePurchaseRoute, navigation = _this$props2.navigation, setPrePurchaseRouteParams = _this$props2.setPrePurchaseRouteParams, setPromoCode = _this$props2.setPromoCode, formUrl = _this$props2.formUrl, KYCResult = _this$props2.KYCResult, setPrePurchaseData = _this$props2.setPrePurchaseData, postStartWebPurchase = _this$props2.postStartWebPurchase;
              _this.setState({
                validatedStage: stage
              });
              if (!success) {
                _context.next = 62;
                break;
              }
              redirecturl = "https://".concat(window.location.hostname, "/").concat(Screens.FinishWebPurchase, "?fix=me");
              if (window.location.hostname === 'localhost') {
                redirecturl = "https://".concat(window.location.hostname, ":3000/").concat(Screens.FinishWebPurchase, "?fix=me");
              }
              if (!addressAvailable) {
                _context.next = 26;
                break;
              }
              ptype = purchaseType === PurchaseTypes.CURRENCY ? PurchaseTypes.CURRENCY : purchaseType === PurchaseTypes.PIGGY_BANK ? purchaseType : PurchaseTypes.CONSUMABLE;
              buyItemParams = {
                ptype: ptype,
                currpkgid: packageId,
                redirecturl: redirecturl,
                redirectOnSuccess: false
              };
              buyItemParams.address1 = form.billingInfoAddress || validatedData.address1;
              buyItemParams.address2 = form.billingInfoAddress2 || validatedData.address2 || '';
              buyItemParams.city = form.billingInfoCity || validatedData.city;
              buyItemParams.country = form.billingInfoCountry || validatedData.country;
              buyItemParams.state = form.billingInfoState || validatedData.state;
              buyItemParams.zip = form.billingInfoZip || validatedData.zip;
              _context.next = 18;
              return postStartWebPurchase(buyItemParams);
            case 18:
              response = _context.sent;
              if (!(response && response.success)) {
                _context.next = 24;
                break;
              }
              _this.props.setFormUrl(response.formurl);
              _this.props.showCustomModal(false);
              _context.next = 26;
              break;
            case 24:
              _this.setState({
                errorMessage: response.error || response.message
              });
              return _context.abrupt("return", null);
            case 26:
              QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_WEB_PURCHASE_TID, undefined), RouteParamConstants.PARAM_WEB_PURCHASE_TOKEN_ID, undefined));
              newStage = stage + 1;
              if (validatedData && validatedData !== undefined) {
                _this.setState({
                  stage: newStage,
                  form: _objectSpread(_objectSpread({}, form), validatedData)
                });
              } else {
                _this.setState({
                  stage: newStage
                });
              }
              setPrePurchaseRoute(_this.getActiveRouteState(navigation.state).routeName);
              // Stage 3: API Requests
              if (!(newStage === 3)) {
                _context.next = 62;
                break;
              }
              lastDigits = undefined;
              if (form.saveCard || validatedData.saveCard) {
                cardNickname = form.cardNickname ? form.cardNickname : validatedData.cardNickname;
                creditCardType = form.cardType ? form.cardType : validatedData.cardType;
                lastDigits = form.cardNumber ? form.cardNumber.slice(-4) : validatedData.cardNumber.slice(-4);
              }
              // This persists with redux persist for when we reload
              setPrePurchaseData({
                cardNickname: cardNickname,
                creditCardType: creditCardType,
                lastDigits: lastDigits
              });
              routeParams = {};
              activeRouteState = _this.getActiveRouteState(navigation.state);
              activeRouteStateParams = activeRouteState.params || {};
              gid = activeRouteStateParams.gid;
              if (gid !== undefined) {
                routeParams[RouteParamConstants.PARAM_GAME_ID] = gid;
              }
              routeParams[RouteParamConstants.PARAM_PURCHASE_TYPE] = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_TYPE, undefined);
              routeParams[RouteParamConstants.PARAM_PURCHASE_SKU] = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_SKU, undefined);
              routeParams.packageDetail = statePackage;
              setPrePurchaseRouteParams(routeParams);
              if (typeof promoReward === 'object') {
                setPromoCode(promoCode);
              } else {
                setPromoCode(undefined);
              }
              _ptype = purchaseType === PurchaseTypes.CURRENCY ? PurchaseTypes.CURRENCY : purchaseType === PurchaseTypes.PIGGY_BANK ? purchaseType : PurchaseTypes.CONSUMABLE;
              billingInfo = _this.getBillingInfoBasedOnClient(validatedData, form);
              _buyItemParams = {
                ptype: _ptype,
                currpkgid: packageId,
                redirecturl: redirecturl,
                billing: billingInfo,
                redirectOnSuccess: true,
                // Not required
                firstname: undefined,
                lastname: undefined,
                year: undefined,
                month: undefined,
                day: undefined
              };
              if (dynamicTriggeredSaleId > 0) {
                _buyItemParams.saleId = dynamicTriggeredSaleId;
              }
              _context.t0 = _this.props.paymentProvider;
              _context.next = _context.t0 === PaymentProviders.CAMS ? 51 : 53;
              break;
            case 51:
              sendDataToCAMS(_buyItemParams, formUrl);
              return _context.abrupt("break", 61);
            case 53:
              _buyItemParams.address1 = form.billingInfoAddress;
              _buyItemParams.address2 = form.billingInfoAddress2;
              _buyItemParams.city = form.billingInfoCity;
              _buyItemParams.country = form.billingInfoCountry;
              _buyItemParams.state = form.billingInfoState;
              _buyItemParams.zip = form.billingInfoZip;
              postStartWebPurchase(_buyItemParams);
              return _context.abrupt("break", 61);
            case 61:
              if (statePackage && statePackage.OFFER_ID) {
                try {
                  InboxMessagesProvider.removeMessage(statePackage.OFFER_ID);
                } catch (e) {
                  console.error(e);
                }
              }
            case 62:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    _this.getBillingInfoBasedOnClient = function (validatedData, form) {
      if (_this.props.paymentProvider === PaymentProviders.CAMS && Utils.isWebOrMobileWeb()) {
        return {
          cc: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardNumber) || (validatedData === null || validatedData === void 0 ? void 0 : validatedData.cardNumber),
          cvv: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardCVV) || (validatedData === null || validatedData === void 0 ? void 0 : validatedData.cardCVV),
          expiryMonth: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardExpiryMonth) || (validatedData === null || validatedData === void 0 ? void 0 : validatedData.cardExpiryMonth),
          expiryYear: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardExpiryYear) || (validatedData === null || validatedData === void 0 ? void 0 : validatedData.cardExpiryYear)
        };
      } else {
        return {
          cc: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardNumber) || (form === null || form === void 0 ? void 0 : form.cardNumber),
          cvv: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardCVV) || (form === null || form === void 0 ? void 0 : form.cardCVV),
          expiryMonth: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardExpiryMonth) || (form === null || form === void 0 ? void 0 : form.cardExpiryMonth),
          expiryYear: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardExpiryYear) || (form === null || form === void 0 ? void 0 : form.cardExpiryYear)
        };
      }
    };
    _this.LoadBillingProfile = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (_this.props.paymentProvider === PaymentProviders.CAMS && Utils.isWebOrMobileWeb() && _this.props.purchaseProfile.length === 0 && _this.state.stage === 1 && ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'sga') _this.props.showCustomModal(true);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    _this.getActiveRouteState = function (route) {
      if (!route.routes || route.routes.length === 0 || route.index >= route.routes.length) {
        return route;
      }
      var childActiveRoute = route.routes[route.index];
      return _this.getActiveRouteState(childActiveRoute);
    };
    _this.buyWithBillingProfile = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(pid) {
        var _store$getState$gameI;
        var active_game_id, trigger_id, _this$state2, purchaseType, packageId, statePackage, _statePackage$PRICE, ptype, _this$props3, promoLink, isOutOfCoinsPurchase, transactionUUID, ltoPurchase, isLTOPurchase, clearLTOOffer, coin, level, loyalty, gameInfo, postBuyItemWithBillingProfile, clearPurchaseInProgress, params, result, trigger, platform, _store, loggerParams;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              active_game_id = ((_store$getState$gameI = store.getState().gameInfo) === null || _store$getState$gameI === void 0 ? void 0 : _store$getState$gameI.gameId) || null;
              trigger_id = store.getState().purchase.actionTrigger;
              _this$state2 = _this.state, purchaseType = _this$state2.purchaseType, packageId = _this$state2.packageId, statePackage = _this$state2.package;
              if (!(pid === -1)) {
                _context3.next = 8;
                break;
              }
              _this._nextHandle(true);
              ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'sga' && _this.props.showCustomModal(true);
              _context3.next = 32;
              break;
            case 8:
              if (!(pid >= 0)) {
                _context3.next = 32;
                break;
              }
              _this.setState({
                stage: 3
              });
              _this.props.showCustomModal(false);
              ptype = purchaseType === PurchaseTypes.CURRENCY ? PurchaseTypes.CURRENCY : purchaseType === PurchaseTypes.PIGGY_BANK ? purchaseType : PurchaseTypes.CONSUMABLE;
              _this$props3 = _this.props, promoLink = _this$props3.promoLink, isOutOfCoinsPurchase = _this$props3.isOutOfCoinsPurchase, transactionUUID = _this$props3.transactionUUID, ltoPurchase = _this$props3.ltoPurchase, isLTOPurchase = _this$props3.isLTOPurchase, clearLTOOffer = _this$props3.clearLTOOffer, coin = _this$props3.coin, level = _this$props3.level, loyalty = _this$props3.loyalty, gameInfo = _this$props3.gameInfo, postBuyItemWithBillingProfile = _this$props3.postBuyItemWithBillingProfile, clearPurchaseInProgress = _this$props3.clearPurchaseInProgress;
              params = {
                ptype: ptype,
                currpkgid: packageId,
                profile: pid,
                messageId: statePackage.OFFER_ID || null
              };
              if (promoLink && promoLink.active && !statePackage.OFFER_ID) {
                params.promocode = promoLink.code;
              }
              _context3.next = 17;
              return postBuyItemWithBillingProfile(_objectSpread(_objectSpread({}, params), {}, {
                active_game_id: active_game_id,
                trigger_id: trigger_id
              }));
            case 17:
              result = _context3.sent;
              trigger = Logger.getActionTrigger();
              platform = Utils.getPlatform();
              _context3.t0 = platform;
              _context3.next = _context3.t0 === PLATFORM.WEB ? 23 : _context3.t0 === PLATFORM.MOBILE_WEB ? 25 : _context3.t0 === PLATFORM.IOS ? 27 : 29;
              break;
            case 23:
              _store = 'cams';
              return _context3.abrupt("break", 30);
            case 25:
              _store = 'cams';
              return _context3.abrupt("break", 30);
            case 27:
              _store = 'appstore';
              return _context3.abrupt("break", 30);
            case 29:
              _store = platform;
            case 30:
              loggerParams = {
                amount: (_statePackage$PRICE = statePackage === null || statePackage === void 0 ? void 0 : statePackage.PRICE) !== null && _statePackage$PRICE !== void 0 ? _statePackage$PRICE : statePackage === null || statePackage === void 0 ? void 0 : statePackage.price,
                product_id: packageId,
                type: purchaseType === PurchaseTypes.PIGGY_BANK ? purchaseType : purchaseType === PurchaseTypes.CURRENCY ? 'regular' : 'vip',
                currency: 'usd',
                store: _store,
                trigger: trigger,
                store_tx_id: result.transaction_id,
                id: transactionUUID,
                tx_error: result.error,
                promo_code: params.promocode,
                game_id: gameInfo.gameId,
                game_provider: gameInfo.gameProvider,
                product_name: statePackage.NAME,
                loyalty_points: statePackage.BONUS_LOYALTY_AMOUNT,
                loyalty_points_before: loyalty.value,
                level_after: level,
                coins: statePackage.AMOUNT,
                promo_coins: statePackage.AMOUNT_INCLUDING_SALE_AND_PROMO,
                balance_before: coin.value
              };
              if (result.success) {
                _this.setState({
                  stage: 4
                });
                Logger.sendEvent(EVENT_TYPES.PURCHASE_COMPLETE, loggerParams);
                if (purchaseType === PurchaseTypes.PIGGY_BANK) {
                  QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.PiggyBank), RouteParamConstants.PARAM_PIGGY_BANK_PURCHASE_SUCCESS, 'true'));
                } else {
                  QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.PurchaseSucceeded));
                }
                isOutOfCoinsPurchase(false);
                clearPurchaseInProgress();
                ltoPurchase && clearLTOOffer();
                isLTOPurchase(false);
                if (statePackage && statePackage.OFFER_ID) {
                  try {
                    InboxMessagesProvider.removeMessage(statePackage.OFFER_ID);
                  } catch (e) {
                    console.error(e);
                  }
                }
              } else {
                Logger.sendEvent(EVENT_TYPES.TRANSACTION_FAILED, loggerParams);
                _this.setState({
                  stage: 5
                });
                clearPurchaseInProgress();
              }
            case 32:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    _this.deleteBillingProfile = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(pid) {
        var postRemoveBillingProfile;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              postRemoveBillingProfile = _this.props.postRemoveBillingProfile;
              _context4.next = 3;
              return postRemoveBillingProfile({
                profile: pid
              });
            case 3:
              _this.props.setPurchaseProfile(_this.props.purchaseProfile.filter(function (profile) {
                return String(profile.profile_id) !== String(pid);
              }));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }();
    _this.contactSupport = function () {
      _this.props.dismissPurchase();
      QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.Settings), RouteParamConstants.PARAM_SETTINGS_SCREEN, SettingsScreensEnum.customerSupport));
    };
    _this.state = {
      validatedStage: 0,
      stage: _this.props.purchaseProfile.length === 0 ? 1 : 0,
      package: null,
      packageId: '',
      packageName: '',
      purchaseType: '',
      offerDetail: null,
      dynamicTriggeredSaleId: 0,
      promoCode: undefined,
      promoReward: undefined,
      errorMessage: '',
      /** @type {import("../../api/Constants").BillingProfile[]|undefined} */
      form: {
        billingInfoAddress1: '',
        billingInfoAddress2: '',
        billingInfoCountry: '',
        billingInfoCity: '',
        billingInfoState: '',
        billingInfoZip: '',
        billingInfoCardType: '',
        billingInfoCardNumber: '',
        billingInfoCardExpiryMonth: '',
        billingInfoCardExpiryYear: '',
        billingInfoCardCVV: '',
        billingInfoCardNickname: '',
        billingInfoSaveCard: '',
        billingInfoPromoCode: '',
        billingInfoFirstname: '',
        billingInfoLastname: '',
        billingInfoYear: '',
        billingInfoMonth: '',
        billingInfoDay: ''
      }
    };
    _this.state.packageId = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_SKU, null);
    _this.state.purchaseType = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_TYPE, null);
    _this.state.packageName = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_NAME, null);
    _this.state.offerDetail = QueryParamsProxy.findParam(RouteParamConstants.PARAM_OFFER_DETAIL, null);
    _this.state.dynamicTriggeredSaleId = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_DTS_ID, null);
    var _result = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_FINISHED_RESULT, undefined);
    var isPlatformMobile = !Utils.isWebOrMobileWeb();
    var findItemId = 'item_id';
    if (isPlatformMobile) {
      findItemId = 'sku';
    }
    var _this$state3 = _this.state,
      _purchaseType = _this$state3.purchaseType,
      _dynamicTriggeredSaleId = _this$state3.dynamicTriggeredSaleId,
      _packageId = _this$state3.packageId,
      offerDetail = _this$state3.offerDetail;
    var _this$props4 = _this.props,
      dynamicTriggeredSale = _this$props4.dynamicTriggeredSale,
      outOfCoinsPurchase = _this$props4.outOfCoinsPurchase,
      outOfCoins = _this$props4.outOfCoins,
      shopList = _this$props4.shopList,
      _ltoOffer = _this$props4.ltoOffer,
      _ltoPurchase = _this$props4.ltoPurchase;
    switch (_purchaseType) {
      case PurchaseTypes.CURRENCY:
        if (_dynamicTriggeredSaleId > 0) {
          _this.state.package = {
            AMOUNT: dynamicTriggeredSale.currOffering.amount,
            PRICE: dynamicTriggeredSale.currPrice
          };
        } else {
          findItemId = 'CURRENCY_ITEM_ID';
          if (isPlatformMobile) {
            findItemId = 'MOBILE_PRODUCT_IAP_ID';
          }
          if (outOfCoinsPurchase) {
            _this.state.package = outOfCoins;
          } else if (_ltoPurchase) {
            _this.state.package = _ltoOffer;
          } else if (offerDetail) {
            _this.state.package = {
              AMOUNT: offerDetail.amount,
              PRICE: offerDetail.price,
              CURRENCY_ITEM_ID: offerDetail.cpil_id,
              OFFER_ID: offerDetail.messageId
            };
          } else {
            _this.state.package = shopList.coins.find(function (item) {
              return item[findItemId] === _packageId;
            });
          }
        }
        break;
      case PurchaseTypes.VIP:
      case PurchaseTypes.CONSUMABLE:
        _this.state.package = shopList.vip.find(function (item) {
          return item[findItemId] === _packageId;
        });
        break;
      case PurchaseTypes.PIGGY_BANK:
        if (offerDetail) {
          _this.state.package = {
            AMOUNT: offerDetail.amount,
            PRICE: offerDetail.price,
            CURRENCY_ITEM_ID: offerDetail.cpil_id
          };
        }
        break;
      default:
        console.error('Invalid pruchaseType.');
    }

    // If there's a purchase result
    if (_result !== undefined) {
      // Check the status, then go to the right stage
      if (_result === PurchaseFinishedResults.SUCCESS) {
        _this.state.stage = 4;
      } else {
        _this.state.stage = 5;
      }
    } else {
      // No purchase result yet
      // Get available billing profiles
      _this.LoadBillingProfile();
    }
    return _this;
  }
  _inherits(PurchaseFlow, _Component);
  return _createClass(PurchaseFlow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$state4 = this.state,
        statePackage = _this$state4.package,
        purchaseType = _this$state4.purchaseType,
        packageId = _this$state4.packageId;
      var mobileHandle = this.props.mobileHandle;
      if (mobileHandle) {
        var ptype = purchaseType === PurchaseTypes.CURRENCY ? PurchaseTypes.CURRENCY : PurchaseTypes.CONSUMABLE;
        mobileHandle(packageId, ptype, statePackage);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // set initiatePurchase to false, used on mobile to mount PurchaseFlow in LobbyOverlay
      this.props.dismissPurchase();
      this.props.showCustomModal(false);
      this.props.clearPurchaseInProgress();
      this.checkLTOOnExit();
      QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_PURCHASE_SKU, undefined), RouteParamConstants.PARAM_PURCHASE_TYPE, undefined), RouteParamConstants.PARAM_PURCHASE_NAME, undefined), RouteParamConstants.PARAM_MSG, undefined), RouteParamConstants.PARAM_PURCHASE_FINISHED_RESULT, undefined), RouteParamConstants.PARAM_PURCHASE_DTS_ID, undefined), RouteParamConstants.PARAM_OFFER_DETAIL, undefined));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        render = _this$props5.render,
        shopList = _this$props5.shopList,
        gameInfo = _this$props5.gameInfo,
        target = _this$props5.target,
        shouldShowCustomModal = _this$props5.shouldShowCustomModal,
        assetsUrls = _this$props5.assetsUrls,
        formUrl = _this$props5.formUrl;
      var _this$state5 = this.state,
        validatedStage = _this$state5.validatedStage,
        stage = _this$state5.stage,
        purchaseType = _this$state5.purchaseType,
        packageId = _this$state5.packageId,
        packageName = _this$state5.packageName,
        promoReward = _this$state5.promoReward,
        statePackage = _this$state5.package,
        errorMessage = _this$state5.errorMessage;
      return render(
      // Pass state and handlers to platform renderer
      {
        validationStage: validatedStage,
        stage: stage,
        nextHandle: this._nextHandle,
        coinList: shopList.coins,
        vipList: shopList.vip,
        purchaseType: purchaseType,
        sku: packageId,
        packageName: packageName,
        buyWithBillingProfile: this.buyWithBillingProfile,
        deleteBillingProfile: this.deleteBillingProfile,
        promoReward: promoReward,
        profiles: this.props.purchaseProfile,
        packageData: statePackage,
        dismissPurchase: this.props.dismissPurchase,
        contactSupport: this.contactSupport,
        gameInfo: gameInfo,
        offerDetail: this.state.offerDetail,
        target: target,
        errorMessage: errorMessage,
        shouldShowCustomModal: shouldShowCustomModal,
        termsAndConditionsUrl: assetsUrls ? assetsUrls.termsAndConditions : '',
        formUrl: formUrl
      });
    }
  }]);
}(Component);
export { PurchaseFlow as default };